import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { Routes } from "router";

/**
 * UNPROTECTED ROUTE COMPONENT
 *
 * ===============================================
 *
 * This component houses all routes and their respective layouts.
 * To add a route navigate to the route builder and add to the existing list.
 *
 *
 */

const UnprotectedRoute: React.FC<{ children: any }> = ({ children }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const rememberMe =
      localStorage.getItem("precisionRememberMe") &&
      localStorage.getItem("precisionAccess") &&
      localStorage.getItem("precisionRefresh");

    // "Remember me" only means: don't make them log in again. The single place
    // that should skip past is the auth flow itself — everything else here is
    // public (landing, pricing, legal, shared reports, candidate assessments)
    // and must stay reachable while signed in.
    const authPaths = [
      Routes.signin,
      Routes.signup,
      Routes.forgotPassword,
      Routes.newPassword,
    ];
    const isAuthPage = authPaths.some((p) => pathname.startsWith(p));

    if (rememberMe && isAuthPage) navigate(Routes.publishAssessment);
  }, [pathname]);

  return <>{children}</>;
};

export { UnprotectedRoute };
